export const chartHasValues = collection => {
  const datasets = collection?.datasets || [];
  return datasets.some(dataset =>
    (dataset.data || []).some(value => Number(value) > 0)
  );
};
